import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column kn-flex workspace-scrollable-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Message = _resolveComponent("Message")
  const _component_DatasetPreviewTable = _resolveComponent("DatasetPreviewTable")
  const _component_KnParameterSidebar = _resolveComponent("KnParameterSidebar")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Dialog, {
    style: _ctx.workspaceDataPreviewDialogDescriptor.dialog.style,
    contentStyle: _ctx.workspaceDataPreviewDialogDescriptor.dialog.contentStyle,
    visible: _ctx.visible,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, {
        class: "kn-toolbar kn-toolbar--primary p-col-12",
        style: _ctx.mainDescriptor.style.maxWidth
      }, {
        start: _withCtx(() => [
          _createVNode("span", null, _toDisplayString(_ctx.dataset?.label), 1)
        ]),
        end: _withCtx(() => [
          (_ctx.isParameterSidebarVisible)
            ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                key: 0,
                icon: "pi pi-filter",
                class: "p-button-text p-button-rounded p-button-plain",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.parameterSidebarVisible = !_ctx.parameterSidebarVisible))
              }, null, 512)), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.filter'),
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "kn-button p-button-text p-button-plain",
            label: _ctx.$t('common.close'),
            onClick: _ctx.closeDialog
          }, null, 8, ["label", "onClick"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar p-ml-2",
            "data-test": "progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_1, [
        (_ctx.errorMessageVisible)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              class: "p-m-2",
              severity: "warn",
              closable: false,
              style: _ctx.mainDescriptor.style.message
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
              ]),
              _: 1
            }, 8, ["style"]))
          : (_openBlock(), _createBlock(_component_DatasetPreviewTable, {
              key: 1,
              class: "p-d-flex p-flex-column kn-flex p-m-2",
              previewColumns: _ctx.columns,
              previewRows: _ctx.rows,
              pagination: _ctx.pagination,
              previewType: _ctx.previewType,
              onPageChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updatePagination($event))),
              onSort: _ctx.onSort,
              onFilter: _ctx.onFilter
            }, null, 8, ["previewColumns", "previewRows", "pagination", "previewType", "onSort", "onFilter"])),
        (_ctx.parameterSidebarVisible && _ctx.dataset)
          ? (_openBlock(), _createBlock(_component_KnParameterSidebar, {
              key: 2,
              style: {"height":"calc(100% - 35px)"},
              class: "workspace-parameter-sidebar kn-overflow-y",
              filtersData: _ctx.filtersData,
              propDocument: _ctx.dataset,
              propMode: _ctx.sidebarMode,
              propQBEParameters: _ctx.dataset.pars,
              userRole: _ctx.userRole,
              dataset: _ctx.dataset,
              onExecute: _ctx.onExecute,
              onRoleChanged: _ctx.onRoleChange,
              loadFromDatasetManagement: _ctx.loadFromDatasetManagement,
              correctRolesForExecution: _ctx.correctRolesForExecution
            }, null, 8, ["filtersData", "propDocument", "propMode", "propQBEParameters", "userRole", "dataset", "onExecute", "onRoleChanged", "loadFromDatasetManagement", "correctRolesForExecution"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["style", "contentStyle", "visible"]))
}